import request from '@/utils/request';
import pimRequest from '@/utils/pimRequest';

// 获取医生微信绑定状态
// export function getPhysicianWeixin(physician_id) {
//   return request({
//     url: `/api/standard/odata/PhysicianWeixins?$filter=physician_id eq '${physician_id}'`,
//     method: 'get',
//   });
// }

export function getKvpByKvpId(kvp_id) {
  return request({
    url: `/api/standard/odata/KvpKeys?$filter=kvp_id eq '${kvp_id}'&$select=kvp_key_name,kvp_key_id&$orderby=sequence`,
    method: 'get',
  });
}
export function getKvpByKvpIdAndParent(kvp_id, parent_kvp_key_id) {
  return request({
    url: `/api/standard/odata/KvpKeys?$filter=(kvp_id eq '${kvp_id}' and parent_kvp_key_id eq '${parent_kvp_key_id}')&$select=kvp_key_name,kvp_key_id&$orderby=sequence`,
    method: 'get',
  });
}

export function getPathologies() {
  return request({
    url: `/api/standard/odata/Pathologies?$orderby=pathology_id`,
    method: 'get',
  });
}

export function getContents(content_name, pathology, section, category) {
  let filter = `is_valid eq 1 and is_hcp360 eq 1 and contains(content_name, '${content_name}')`;
  if (pathology) {
    filter += ` and content__content_pathologies/any(p: p/pathology_id eq '${pathology}')`;
  }
  if (section) {
    filter += ` and content_section_kvp eq '${section}'`;
  }
  if (category) {
    filter += ` and content_category_kvp eq '${category}'`;
  }
  return request({
    url: `/api/standard/OData/Contents?$expand=content__content_pathologies,content__content_products&$select=content_id,content_name,content_section_kvp,content_category_kvp,content_type,thumb,description,comment,content_body,s3_file_name,publish_date,is_promo,recommended_wording,wx_logo&$filter=${filter}&$orderby=publish_date desc`,
    method: 'get',
  });
}

export function getContentById(content_id) {
  return request({
    url: `/api/standard/OData/Contents?$expand=content__content_pathologies&$filter=content_id eq '${content_id}'`,
    method: 'get',
  });
}

// 微信内容相关统计
export function getContentStats(physician_id) {
  return request({
    url: `/api/standard/odata/VStatPhysicianContentLogs?$filter=physician_id eq '${physician_id}'`,
    method: 'get',
  });
}

// 记录发送内容
export function logContentSend(data) {
  return pimRequest({
    url: `/api/custom/ContentLog/Send`,
    method: 'post',
    data: data,
  });
}

// 记录打开内容
export function logContentOpen(data) {
  return pimRequest({
    url: `/api/custom/ContentLog/Open`,
    method: 'post',
    data: data,
  });
}

// 记录持续打开内容
export function logContentOpenDuration(data) {
  return pimRequest({
    url: `/api/custom/ContentLog/RefreshOpenDuration`,
    method: 'post',
    data: data,
  });
}

// 记录转发内容
export function logContentForward(data) {
  return pimRequest({
    url: `/api/custom/ContentLog/Forward`,
    method: 'post',
    data: data,
  });
}

// 查询医生微信详情
export function getPhysicianWechatDetail(physician_id) {
  return request({
    url:
      '/api/gateway/PhysicianWeChat/GetPhysicianWeChat?physician_id=' +
      physician_id,
    method: 'get',
  });
}

// 查询医生微信详情
export function getPhysicianWechatDetailByOpenId(open_id) {
  return request({
    url: '/api/gateway/PhysicianWeChat/GetPhysicianWeChat?open_id=' + open_id,
    method: 'get',
  });
}

// 查询内容发送详情
export function getLogContentSend(send_id) {
  return pimRequest({
    url: `/api/custom/ContentLog/GetLogSend?log_content_send_id=` + send_id,
    method: 'get',
  });
}

// 查询内容详情
export function getContent(send_id) {
  return pimRequest({
    url: `/api/custom/ContentLog/GetContent?log_content_send_id=` + send_id,
    method: 'get',
  });
}

// 绑定医生
export function weixinBind(data) {
  return request({
    url: `/api/gateway/PhysicianWechat/Bind`,
    method: 'post',
    data: data,
  });
}

// 签署consent
export function signConsent(data) {
  return request({
    url: `/api/gateway/PhysicianWechat/Consent`,
    method: 'post',
    data: data,
  });
}

// 解除绑定医生
export function weixinUnbind(data) {
  return request({
    url: `/api/gateway/PhysicianWechat/Unbind`,
    method: 'post',
    data: data,
  });
}

// 请求审批解除绑定医生
export function weixinUnbindApply(id) {
  return request({
    url: `/api/standard/odata/PhysicianWeixins('${id}')`,
    method: 'patch',
    data: {unbind_pending_approval: 1},
  });
}

// 审批解除绑定医生完成
export function weixinUnbindFinishApplication(id) {
  return request({
    url: `/api/standard/odata/PhysicianWeixins('${id}')`,
    method: 'patch',
    data: {unbind_pending_approval: 0},
  });
}

// 取消签署consent
export function unsignConsent(data) {
  return request({
    url: `/api/gateway/PhysicianWechat/Unconsent`,
    method: 'post',
    data: data,
  });
}

// 请求审批取消签署consent
export function weixinUnconsentApply(id) {
  return request({
    url: `/api/standard/odata/PhysicianWeixins('${id}')`,
    method: 'patch',
    data: {unconsent_pending_approval: 1},
  });
}

// 审批取消签署consent完成
export function weixinUnconsentFinishApplication(id) {
  return request({
    url: `/api/standard/odata/PhysicianWeixins('${id}')`,
    method: 'patch',
    data: {unconsent_pending_approval: 0},
  });
}

// 查询发送给医生的内容
export function getAllContentSend(physician_id) {
  return request({
    url: `/api/standard/odata/LogContentSends?$filter=receiver_physician_id eq '${physician_id}'&$orderby=send_time desc&$expand=content`,
    method: 'get',
  });
}

// 查询医生打开的内容
export function getAllContentOpen(physician_id) {
  return request({
    url: `/api/standard/odata/LogContentOpens?$filter=physician_id eq '${physician_id}'&$orderby=open_time desc&$expand=content`,
    method: 'get',
  });
}

// 查询发送给医生的内容
export function getPhysicianContentSend(physician_id, content_id) {
  return request({
    url: `/api/standard/odata/LogContentSends?$filter=receiver_physician_id eq '${physician_id}' and content_id eq '${content_id}'&$orderby=send_time desc&$expand=content`,
    method: 'get',
  });
}

// 查询医生打开的内容
export function getPhysicianContentOpen(physician_id, content_id) {
  return request({
    url: `/api/standard/odata/LogContentOpens?$filter=physician_id eq '${physician_id}' and content_id eq '${content_id}'&$orderby=open_time desc&$expand=content`,
    method: 'get',
  });
}

// 获取问卷定义
export function getQuestionnaire(content_id) {
  return pimRequest({
    url: `/api/custom/Questionnaire/GetQuestionnaire?content_id=${encodeURIComponent(content_id)}`,
    method: 'get',
  });
}

// 获取问卷定义
export function getQuestionnaireById(questionnaire_id) {
  return pimRequest({
    url: `/api/custom/Questionnaire/GetQuestionnaire?questionnaire_id=${encodeURIComponent(questionnaire_id)}`,
    method: 'get',
  });
}

// 保存问卷答案
export function saveQuestionnaireResult(data) {
  return pimRequest({
    url: `/api/custom/Questionnaire/SaveQuestionnaireResult`,
    method: 'post',
    data,
  });
}

// 获取指定季度内，内容发送与打开统计数据
export function getContentSendOpenStats(params) {
  return request({
    url: `api/gateway/ContentKPI/GetContentSendOpenStats`,
    method: 'get',
    params,
  });
}

// 获取指定季度内，用户向医生发送内容的统计数据（包含发送量与打开量）
export function getPhysicianContentSendOpenStats(params) {
  return request({
    url: `api/gateway/ContentKPI/GetPhysicianContentSendOpenStats`,
    method: 'get',
    params,
  });
}
